<template>
  <div>
      <el-form>
        <el-form-item>
          用户名称：
          <el-input style="width:50%" v-model="tu_username"></el-input>
        </el-form-item>
        <el-form-item>
          用户账号：
          <el-input style="width:50%" v-model="tu_phone"></el-input>
        </el-form-item>
        <el-form-item>
          用户密码：
          <el-input style="width:50%" v-model="tu_password"></el-input>
        </el-form-item>
        <el-form-item>
          角色状态：<el-switch
          v-model="tu_valid"
          active-color="#13ce66"
          inactive-color="#ff4949">
        </el-switch>
        </el-form-item>
        <el-button @click="save">保存</el-button>
      </el-form>
  </div>
</template>

<script>
  export default {
    inject:['reload'],
    name: 'AddAdmin',
    data(){
      return {
        tu_username:'',
        tu_phone: '',
        tu_password: '',
        tu_valid:null
      }
    },
    methods:{
      save(){
        this.$inbound.post({
          interfaceId: 'user/insertFromUser',
          data:{
            tu_username: this.tu_username,
            tu_phone: this.tu_phone,
            tu_password: this.tu_password,
            tu_valid: this.tu_valid,
            tu_from:1,
          }
        }).then(response => {
          if (response==1){
            window.location.reload()
          }else if(response==4001){
            this.$message.warning("添加用户失败")
          }
        }).catch(error => {
          console.log(error)
        })
      },
      close (){
        this.$emit('close')
      }
    }

  }
</script>
